import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppConditionPriceMinMaxAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        label="Price min & max alert"
        placeholder="Select price min & max alert"
        urlAjax={`${BACKEND_APIS.CRUD}/user/min_max_price_comparison?selectorFormat=true`}
        {...props}
    />
}